import {
  AfterContentInit,
  Component,
  ElementRef,
  HostListener,
  Injectable,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import {ModalCompileContext} from "../../ModalCompileContext";
import {ModalWindowTheme, needToShowBackdrop} from "../../IModalOptions";
import {IScrollProvider, SCROLL_PROVIDER} from "n-framework/n-sticky";
import {ModalService} from "../../ModalService";

export const N_MODAL_LAYER_SELECTOR = "n-modal-layer";

@Injectable({providedIn: "root"})
export class ModalLayerScrollProvider implements IScrollProvider {

  constructor(private el: ElementRef) {
  }

  getScrollContainer(): Element {
    return this.el.nativeElement;
  }

}

export interface IPopoverHostOverride {
  getHost(): Element;
}

@Injectable({providedIn: "root"})
export class ModalLayerPopoverHostOverride implements IPopoverHostOverride {

  constructor(private modalSvc: ModalService) {
  }

  getHost(): Element {
    return this.modalSvc.getModalContainer();
  }

}

@Component({
  selector: N_MODAL_LAYER_SELECTOR,
  templateUrl: "./n-modal-layer.html",
  styleUrls: [
    "./n-modal-layer.css",
  ],
  providers: [
    {
      provide: SCROLL_PROVIDER,
      useClass: ModalLayerScrollProvider
    }
  ]
})
export class NModalLayerComponent implements AfterContentInit, OnInit {

  @ViewChild("content", {read: ViewContainerRef, static: true})
  readonly contentVc: ViewContainerRef;

  @ViewChild("wrapper", {read: ElementRef, static: true})
  readonly windowContentElement: ElementRef;

  theme: ModalWindowTheme;

  private preventClose: boolean;

  constructor(private compileCtx: ModalCompileContext,
              public hostElement: ElementRef,
              private renderer: Renderer2) {

  }

  ngOnInit(): void {
    this.theme = this.compileCtx.modalCtx.options.windowTheme || "default";
  }

  focus() {
    this.hostElement.nativeElement.focus();
  }

  ngAfterContentInit(): any {
    const wndClass = this.compileCtx.modalCtx.options.windowClass;
    if (wndClass) {
      const classNames = wndClass.split(" ");
      for (const clsName of classNames) {
        this.renderer.addClass(this.hostElement.nativeElement, clsName);
      }
    }

    // create inner component instance
    this.compileCtx.compile(this.contentVc);

    if (!this.compileCtx.modalCtx.options.manualZIndex) {
      this.renderer.setStyle(this.hostElement.nativeElement, "zIndex", (1050 + (this.compileCtx.layerNumber * 10) - 5).toString());
    }
    this.renderer.setProperty(this.hostElement.nativeElement, "tabIndex", "-1");

    this.focus();
  }

  onWindowMouseDown() {
    this.preventClose = true; // prevent close if click starts from another element
  }

  onWindowClick() {
    this.preventClose = true;
  }

  @HostListener("click", ["$event"])
  onClick(evt) {
    if (!needToShowBackdrop(this.compileCtx.modalCtx.options) || this.preventClose || this.isClickOnOverlay(evt)) {
      this.preventClose = false;
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();

    this.compileCtx.modalCtx.cancel();
  }

  /* проверят, был ли клик по оверлею, вызванному модалкой, например по поповеру или выпадашке селекта */
  isClickOnOverlay(event: { target: HTMLElement; }) {
    const domCrawler = (el: HTMLElement) => {
      if (el.hasAttribute("data-popover-host")) {
        return el.getAttribute("data-popover-host") === "_overridden";
      }

      if (!el.parentElement) {
        return false;
      }
      return domCrawler(el.parentElement);
    };
    return domCrawler(event.target);
  }
}
